import { Box } from '@osmosis/react-ui/components/Box';
import { Children, cloneElement, JSX } from 'react';
import { useAccordionItem } from './useAccordion';

/**
 * AccordionItem.
 */
export const AccordionItem = ({
  children,
  index,
}: {
  children: JSX.Element[] | JSX.Element;
  index?: number;
}) => {
  const isOpen = useAccordionItem(index || 0);

  return (
    <Box aria-expanded={isOpen} sx={{ borderBottom: '1px solid black' }}>
      {Children.map(children, (child) => {
        return cloneElement(child, { index, key: index });
      })}
    </Box>
  );
};
